import key from './key';
declare var moment: any;
/**
 * 键值对过滤器
 */
export function filter(value: any, type: any) {
  let val = value;
  if (value) {
    if (!type || !(key as any)[type]) {
      for (let t in key) {
        if ((key as any)[t][value]) {
          val = (key as any)[t][value];
          break;
        }
      }
    } else {
      val = (key as any)[type][value] ? (key as any)[type][value] : val;
    }
  }

  return val;
}
/**
 * 课程状态转换
 * @param {string} status 状态-标志符
 * @return {string} 状态-中文
 */
export function courseStatusFormat(status: string) {
  if (!status) return '';
  let val = '';
  status === 'ON'
    ? (val = '进行中')
    : status === 'NO'
    ? (val = '未开始')
    : status === 'CO'
    ? (val = '已完成')
    : (val = '未知');
  return val;
}

export function timeFormat(time: string) {
  if (!time) {
    return '';
  }
  return moment(time).format('YYYY-MM-DD HH:mm:ss');
}
export function timeFormat2(time: string) {
  if (!time) {
    return '不是时间格式';
  }
  return moment(time).format('MM月DD日 HH:mm:ss');
}
export function timeFormat3(time: string) {
  if (!time) {
    return '';
  }
  return moment(time).format('YYYY-MM-DD HH:mm:ss');
}
// YYYY-MM-DD 格式时间
export function timeFormat4(time: string) {
  if (!time) {
    return '';
  }
  return moment(time).format('YYYY-MM-DD');
}

/**
 * Leads数据状态转换
 * @param {string} status 数据状态
 * @return {string} 转换后的值
 */
export function leadsDSFormat(status: string) {
  if (!status) return '';
  let val = '';
  status === 'NOTLISTEN'
    ? (val = '未试听')
    : status === 'LISTEN'
    ? (val = '已试听')
    : status === 'PAY'
    ? (val = '已付费')
    : status === 'VALID'
    ? (val = '有效数据')
    : status === 'INVALID'
    ? (val = '无效数据')
    : (val = '未知');
  return val;
}

/**
 * @description: 客户满意度转换
 * @param {string} rate 客户满意度
 * @return {string} 转换后的值
 */
export function intentionFormat(rate: string) {
  if (!rate) return '';
  let val = '';
  rate === 'HP'
    ? (val = '高意向')
    : rate === 'P'
    ? (val = '有意向')
    : rate === 'LP'
    ? (val = '低意向')
    : rate === 'OKN'
    ? (val = '无意向')
    : rate === 'NO'
    ? (val = '暂无')
    : (val = '未知');
}

/**
 * @description: 无效原因转换
 * @param {string} reason 无效原因
 * @return {string} 转换后的值
 */
export function invalidReasonFormat(reason: string) {
  if (!reason) return '';
  let val = '';
  reason === 'ERROR'
    ? (val = '空号错号')
    : reason === 'HANGUP'
    ? (val = '直接挂断')
    : reason === 'UNSUIT'
    ? (val = '年龄不符合')
    : reason === 'NODEVICE'
    ? (val = '家里没有设备')
    : reason === 'OTHER'
    ? (val = '其他')
    : (val = '未知');
}

/**
 * 课程包状态转换
 * @param {string} status 课程包状态
 * @return {string} 转换后的值
 */
export function consumeStatusFormat(status: string) {
  if (!status) return '';
  let val = '';
  status === 'CONSUMED'
    ? (val = '已消耗')
    : status === 'REBACK'
    ? (val = '已返还')
    : (val = '未知');
}

/**
 * 处理状态转换
 * @param {string} status 处理状态
 * @return {string} 转换后的值
 */

export function processStatusFormat(status: string) {
  if (!status) return '';
  let val = '';
  status === 'APPLYING'
    ? (val = '处理中')
    : status === 'PASSED'
    ? (val = '已返还')
    : status === 'CANCEL'
    ? (val = '已撤销')
    : status === 'REFUSE'
    ? (val = '已驳回')
    : (val = '未知');
}
/**
 * @description: 作品状态转换
 * @param {string} status 作品状态
 * @return {string} 转换后的值
 */
export function projectStatusFormat(status: string) {
  if (!status) return '';
  let val = '';
  status === 'D'
    ? (val = '删除')
    : status === 'S'
    ? (val = '保存')
    : status === 'DR'
    ? (val = '草稿')
    : status === 'P'
    ? (val = '发布')
    : (val = '未知');
}
/**
 * @description: 课程类型转换
 * @param {string} type 课程类型
 * @return {string} 转换后的值
 */
export function lessonTypeFormat(type: string) {
  if (!type) return '';
  let val = '';
  type === 'LIVE'
    ? (val = '直播课')
    : type === 'OFFLINE'
    ? (val = '线下课')
    : type === 'RECORD'
    ? (val = '录播课')
    : (val = '未知');
  return val;
}

/**
 * @description: 老师状态转换
 * @param {string} status 老师状态
 * @return {string} 转换后的值
 */
export function teacherStatusFormat(status: string) {
  if (!status) return '';
  let val = '';
  status === 'A'
    ? (val = '激活')
    : status === 'I'
    ? (val = '禁用')
    : (val = '删除');

  return val;
}
/**
 * @description: 课时状态转换
 * @param {string} status 课时状态
 * @return {string} 转换后的值
 */
export function lessonParseFormat(status: string) {
  let val = '';
  status === 'BEFORE'
    ? (val = '课前')
    : status === 'AFTER'
    ? (val = '课后')
    : (val = '课中');

  return val;
}
/**
 * @description: 课时时间转换
 * @param {string} val 课时时间
 * @return: 转换后的状态
 */
export function timeLessonFormat(val: string) {
  if (!val) {
    return '不是时间格式';
  }
  return moment(val).format('MM月DD日');
}

/**
 * @description: 客户类型转换-机构端客户
 * @param {Number} type 类型
 * @return: 转换后的类型
 */
export function customerTypeFormat(type: number) {
  let val = '';
  type === 0
    ? (val = '机构')
    : type === 1
    ? (val = '管理中心')
    : type === 2
    ? (val = '学校')
    : '未知';
  return val;
}

/**
 * @description: 分校状态转换
 * @param {string} status 分校状态
 * @return {string} 转换后的值
 */
export function orgStatusFormat(status: string) {
  let val = '';
  status === 'A' ? (val = '启用') : status === 'I' ? (val = '禁用') : '未知';
  return val;
}

/**
 * @description: 激活码状态转换
 * @param {string} status 分校状态
 * @return {string} 转换后的值
 */
export function activationStatusFormat(status: string) {
  let activationStatus = {
    'OFF': '未激活',
    'ON': '使用中',
    'CLOSED': '已作废',
    'CLASSING': '上课中',
    'EXPIRDE': '已过期'
  }
  return (activationStatus as any)[status]
}
